export function decodeBase64Url(data: string): string {
  const normalized = data.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return decodeURIComponent(escape(atob(normalized)));
  } catch (err) {
    console.error("Failed to decode base64", err);
    return "";
  }
}
